module.exports = __webpack_public_path__ + "img/img08.b68e740f.jpg";